import api from './api';

// System Events viewer (360 port of v1 eventhistory.pl). One screen over any
// system that keeps a `systemevent` history — pick with `system`.
const BASE = '/system-events';

export interface SystemOption {
  key: string;
  label: string;
}

export interface SystemEventSummary {
  type: string;
  lastDate: string;
  user: string;
  lastResult: string;
  /** Batch id of the LATEST run, for the Last Results link. */
  batchId: string;
  /** True when that latest run was made here and stored its results. */
  hasDetails: boolean;
  count: number;
}

export interface SystemEventRun {
  datetime: string;
  user: string;
  file: string;
  batchId: string;
  result: string;
  /** True when the run was made HERE and stored its own results. */
  hasDetails: boolean;
}

export interface SystemEventList {
  system: string;
  systems: SystemOption[];
  events: SystemEventSummary[];
}

export interface SystemEventHistory {
  system: string;
  type: string;
  limit: number;
  history: SystemEventRun[];
}

/** One created accessorial, as stored by the Accessorial Upload. */
export interface RunResultRow {
  pronumber?: number;
  mas_tag?: string;
  accessorial_num?: number;
  line_count?: number;
  total?: string;
  [key: string]: unknown;
}

export interface RunResults {
  eventType: string;
  batchId: string;
  user: string;
  file: string;
  createdAt: string;
  payload: {
    invoiceCount?: number;
    lineCount?: number;
    grandTotal?: string;
    totalRows?: number;
    skippedCount?: number;
    created?: RunResultRow[];
    [key: string]: unknown;
  };
}

export const systemEventsService = {
  async list(system?: string): Promise<SystemEventList> {
    const { data } = await api.get<SystemEventList>(BASE, {
      params: system ? { system } : undefined,
    });
    return data;
  },

  async history(type: string, system?: string): Promise<SystemEventHistory> {
    const { data } = await api.get<SystemEventHistory>(BASE, {
      params: { type, ...(system ? { system } : {}) },
    });
    return data;
  },

  /** The stored results of a run made here. 404s for a legacy run. */
  async results(type: string, batchId: string): Promise<RunResults> {
    const { data } = await api.get<RunResults>(`${BASE}/results`, {
      params: { type, batchId },
    });
    return data;
  },
};

export default systemEventsService;
